import { OrderError } from "../Order";

export type CompleteCheckoutError = OrderError<"completeCheckoutError">;
